import { ChangeBackgroundPageList, MenuItems, ToolsPageData } from '~/static/types/tools'
import { hslToRgba, parseRgba, makeRgba } from '~/utils/ColorpickerHelper'

class ToolsService {
  private normalizeColor(color: string): string {
    if (!color) {
      return 'rgba(255,255,255,1)'
    }

    const cleanColor = color.trim().toLowerCase()

    // Обработка формата HSL / HSLA
    if (cleanColor.startsWith('hsl')) {
      const match = cleanColor.match(/^hsla?\((\d+),\s*(\d+)%?,\s*(\d+)%?,?\s*([0-9.]+)?\)/)

      if (match) {
        const h = parseInt(match[1])
        const s = parseInt(match[2])
        const l = parseInt(match[3])
        const alpha = match[4] ? parseFloat(match[4]) * 100 : 100

        const rgba = hslToRgba({ h, s, l, alpha })
        return makeRgba(rgba)
      }
    }

    // Для HEX, RGB и RGBA используются  функции в ColorpickerHelper
    return makeRgba(parseRgba(cleanColor))
  }

  async getChangeBackgroundPageList(): Promise<ChangeBackgroundPageList | undefined> {
    interface ChangeBackgroundsResponse {
      data: ChangeBackgroundPageList
    }

    const config = useRuntimeConfig()

    const response = await $fetch<ChangeBackgroundsResponse>('/change-backgrounds/get-list', {
      baseURL: config.public.adminApiUrl,
      method: 'GET',
    })

    if (response?.data) {
      return response.data.map((item) => {
        return {
          ...item,
          color: this.normalizeColor(item.color),
        }
      })
    }
  }

  async getPageDataBySlug(slug: string): Promise<ToolsPageData | undefined> {
    interface PageDataResponse {
      data: ToolsPageData
    }

    const config = useRuntimeConfig()

    const response = await $fetch<PageDataResponse>(`/change-backgrounds/get-by-slug/${slug}`, {
      baseURL: config.public.adminApiUrl,
      method: 'GET',
    })

    if (response?.data) {
      return response.data
    }
  }

  async getMenuItems(): Promise<MenuItems | undefined> {
    interface MenuResponse {
      data: MenuItems
    }

    const config = useRuntimeConfig()

    const response = await $fetch<MenuResponse>('/change-backgrounds/get-menu', {
      baseURL: config.public.adminApiUrl,
      method: 'GET',
    })

    if (response?.data) {
      return response.data
    }
  }
}

export const toolsService = new ToolsService()
